import { getVariableInfo } from '@dealstack/frontend/shared/components/EmailTemplates/utils/emailVariableCatalog';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Box, Button, Group, Stack, Text, TextInput } from '@mantine/core';

interface Props {
	variables: string[];
	values: Record<string, string>;
	onChange: (values: Record<string, string>) => void;
	onReset: () => void;
}

export const PreviewVariablesForm = ({ variables, values, onChange, onReset }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (variables.length === 0) {
		return (
			<Box p="sm">
				<Text size="md" c="gray.9">
					{tMipManage('email_templates.preview_form.none')}
				</Text>
			</Box>
		);
	}

	return (
		<Box p="sm">
			<Group justify="space-between" align="center" wrap="nowrap" mb={4}>
				<Text fw={600} fz="0.8125rem">
					{tMipManage('email_templates.preview_form.title')}
				</Text>
				<Button variant="subtle" size="compact-xs" onClick={onReset}>
					{tMipManage('email_templates.preview_form.reset')}
				</Button>
			</Group>
			<Text fz="0.75rem" c="gray.9" mb="0.75rem">
				{tMipManage('email_templates.preview_form.hint')}
			</Text>
			<Stack gap="0.75rem">
				{variables.map((name) => {
					const info = getVariableInfo(name);
					return (
						<Box key={name}>
							<Text fz="0.75rem" c="gray.9" mb={4}>
								{info.label}
							</Text>
							<TextInput
								size="sm"
								aria-label={info.label}
								placeholder={tMipManage(
									'email_templates.preview_form.empty_placeholder'
								)}
								value={values[name] ?? ''}
								styles={{ input: { height: 32, minHeight: 32 } }}
								onChange={(event) =>
									onChange({ ...values, [name]: event.currentTarget.value })
								}
							/>
						</Box>
					);
				})}
			</Stack>
		</Box>
	);
};
